import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { removeLocaleFromUrl } from "@faire/web--source/ui/routing/util";
import { route as brandbrandTokenRoute } from "@faire/web-api--source/routes/brand/brandToken";
import { route as flashSaleRoute } from "@faire/web-api--source/routes/flash-sale";
import { route as posHomeRoute } from "@faire/web-api--source/routes/point-of-sale";
import { route as posAboutRoute } from "@faire/web-api--source/routes/point-of-sale/about";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { matchPath } from "react-router-dom";
export var useNonStickyHeader = function(param) {
    var hasLinkedPOS = param.hasLinkedPOS;
    var _useLocation = useLocation(), pathnameWithMaybeLocale = _useLocation.pathname;
    var pathname = useMemo(function() {
        return removeLocaleFromUrl(pathnameWithMaybeLocale);
    }, [
        pathnameWithMaybeLocale
    ]);
    return useMemo(function() {
        var nonStickyHeaderPath = [
            {
                path: brandbrandTokenRoute,
                exact: true
            },
            {
                path: flashSaleRoute,
                exact: true
            },
            {
                path: posAboutRoute,
                exact: true
            }
        ].concat(_to_consumable_array(!hasLinkedPOS ? [
            {
                path: posHomeRoute,
                exact: true
            }
        ] : [])).filter(isNotUndefined);
        return nonStickyHeaderPath.some(function(path) {
            return matchPath(pathname, path) !== null;
        });
    }, [
        pathname,
        hasLinkedPOS
    ]);
};
